import { useEffect } from "react";
import { MonthlyFeeWidget } from "@/widgets/monthlyfee";

export const MonthlyFeePage = () => {
  useEffect(() => {
    document.title = "Сарын хураамж";
  }, []);

  return (
    <div className="page">
      <MonthlyFeeWidget />
    </div>
  );
};
